import { apiPatch } from '@/api/api.ts'
import { AlertPatchType } from '@/api/notification/alertServerValues.ts'
import { resetAlertHistoryCache } from '@/api/notification/alertHistoryCache.ts'

export interface IReqPatchBioAlertAssignPerson {
    manager_name: string;
}

export const apiPatchEmergencyAlertAssignPerson = async (id: number, params: IReqPatchBioAlertAssignPerson) => {
    return await apiPatch<undefined>(`/alert/emergency/${id}`, {
        type: AlertPatchType.ASSIGN,
        manager_name: params.manager_name
    })
}

export interface IReqPatchBioAlertProcess {
    task_content: string;
    task_result: string;
}

export const apiPatchEmergencyAlertProcess = async (id: number, params: IReqPatchBioAlertProcess) => {
    const response = await apiPatch<undefined>(`/alert/emergency/${id}`, {
        type: AlertPatchType.CONFIRM,
        task_result: params.task_result,
        task_content: params.task_content
    })

    if (Number(response.code) === 200) {
        await resetAlertHistoryCache('sos')
    }

    return response
}
